package haxe.ui.containers;

class Header extends HBox {
    public function new() {
        super();
    }
}
